import { render, staticRenderFns } from "./DynamicTreeSelect.vue?vue&type=template&id=2d960fc2&scoped=true&"
import script from "./DynamicTreeSelect.vue?vue&type=script&lang=js&"
export * from "./DynamicTreeSelect.vue?vue&type=script&lang=js&"
import style0 from "./DynamicTreeSelect.vue?vue&type=style&index=0&id=2d960fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d960fc2",
  null
  
)

export default component.exports